let getApi = () => import('@/services/Api');

const state = {
    sdtRows: {},
    sdtConfig: {
        CtlgPrivilege: {url: 'userPermissions', respObject: 'permissions'},
        CtlgRole: {url: 'userRoles', respObject: 'roles'},
        Asset: {url: 'view/Asset', respObject: 'tabRows'},
        AssetHistory: {url: 'assetHistory', respObject: 'history'},
        AssetMaintenance: {url: 'view/AssetMaintenance', respObject: 'tabRows'},
        AssetMaintenanceHistory: {url: 'view/AssetMaintenanceHistory', respObject: 'tabRows'},
        IpmProvision: {url: 'view/IpmProvision', respObject: 'tabRows'},
        EmployeeDiscipline:{url: 'view/EmployeeDiscipline', respObject: 'tabRows'}
    },
    sdtHeaders: {
        CtlgRole: [
            {value: 'code', textCode: 'code', align: 'right'},
            {value: 'name', type: 'name', textCode: 'name', align: 'right'},
            {value: 'createdAt', type: 'DATE', textCode: 'createdAt', align: 'right'},
            {value: 'updatedAt', type: 'DATE', textCode: 'updatedAt', align: 'right'},

        ],
        CtlgPrivilege: [
            {value: 'code', textCode: 'code', align: 'right'},
            {value: 'method', textCode: 'method', align: 'right'},
            {value: 'resourceType', textCode: 'resourceType', align: 'right'},
            {value: 'roleCode', textCode: 'role', align: 'right'},
            {value: 'description', textCode: 'Description', align: 'right'},
        ],
        Asset: [
            {value: 'identNumber', textCode: 'identNumber', align: 'right'},
            {value: 'writeoffDate', textCode: 'writeoffDate', align: 'right', type: 'DATE',},
            {value: 'model', textCode: 'model', align: 'right', type: 'OBJECT',},
            {value: 'status', textCode: 'status', align: 'right', type: 'OBJECT'},
            {value: 'distributionPoint', textCode: 'distributionPoint', align: 'right', type: 'OBJECT'},
            {value: 'description', textCode: 'Description', align: 'right'},
        ],
        AssetHistory: [
            {value: 'eventName', textCode: 'eventName', align: 'right', type:'NAME'},
            {value: 'createdAt', type: 'DATE_TIME', textCode: 'createdAt', align: 'right'},
           //{value: 'assetNumber', textCode: 'assetNumber', align: 'right'},
            //{value: 'assetModel', textCode: 'model', align: 'right'},
            {value: 'assetIssueDate', textCode: 'assetIssueDate', align: 'right', type: 'DATE_TIME'},
            {value: 'assetExpiryDate', textCode: 'assetExpiryDate', align: 'right', type: 'DATE_TIME'},
            {value: 'assetReturnedDate', textCode: 'assetReturnedDate', align: 'right', type: 'DATE_TIME'},
            //{value: 'assetCheckedDate', textCode: 'assetCheckedDate', align: 'right', type: 'DATE_TIME'},
            {value: 'givedTo', textCode: 'asset_issued_total', align: 'right'},
            {value: 'overdue', textCode: 'asset_overdue', align: 'right'},
            {value: 'total', textCode: 'asset_on_hands', align: 'right'},
            {value: 'issueDP', textCode: 'issueDistPoint', align: 'right', type:'NAME'},
            {value: 'returnDP', textCode: 'returnDistPoint', align: 'right', type:'NAME'},
            {value: 'employeeNumber', textCode: 'employeeNumber', align: 'right'},
            {value: 'employeeName', textCode: 'employeeName', align: 'right'},
            {value: 'comment', textCode: 'comment', align: 'right'},
            {value: 'user', textCode: 'user', align: 'right',  type: 'OBJECT', width: '1%'},
        ],
        AssetMaintenance: [
            {value: 'rus', textCode: 'name', align: 'right', width: '1%'},
            {value: 'mPeriod', textCode: 'mPeriod', align: 'right', type: 'INTEGER', width: 20},
            {value: 'lastDate', textCode: 'lastDate', align: 'right', type: 'DATE', width: '1%'},
            {value: 'daysFromLast', textCode: 'daysFromLast', align: 'right', type: 'INTEGER', width: '1%'},
            {value: 'nextCheckDate', textCode: 'nextCheckDate', align: 'right', type: 'DATE', width: '1%'},
            {value: 'empty', textCode: '', align: 'right',},
        ],
        AssetMaintenanceHistory: [
            {value: 'type', textCode: 'type', align: 'right', type: 'OBJECT', width: '1%'},
            {value: 'maintenancePeriod', textCode: 'maintenancePeriod', align: 'right', width: '1%'},
            {value: 'daysFromLast', textCode: 'daysFromLast', align: 'right', width: '1%'},
            {value: 'actDate', type: 'DATE', textCode: 'actDate', align: 'right'},
            {value: 'nextCheckDate', type: 'DATE',textCode: 'nextCheckDate', align: 'right', width: '1%'},
            {value: 'comment', textCode: 'comment', align: 'right', type: 'TEXT', width: '1%'},
            {value: 'issueDistributionPoint', textCode: 'issueDistPoint', align: 'right', type: 'OBJECT', width: '1%'},
            {value: 'user', textCode: 'user', align: 'right',  type: 'OBJECT', width: '1%'},
            {value: 'createdAt', type: 'DATE_TIME', textCode: 'createdAt', align: 'right'},
            {value: 'empty', textCode: '', align: 'right',},
        ],
        IpmProvision: [
            {value: 'rus', textCode: 'assetType', align: 'left'},
            {value: 'count', textCode: 'countNorm', align: 'left'},
            {value: 'assignedCount', textCode: 'assignedCount', align: 'left'},
            {value: 'assignedAssets', textCode: 'assignedAssets', align: 'left',},
            {value: 'empty', textCode: '', align: 'left',},
        ],
        EmployeeDiscipline: [
            {value: 'year', textCode: 'year', align: 'left', },
            {value: 'assigned', textCode: 'assigned', align: 'left',},
            {value: 'lost', textCode: 'lost', align: 'left',},
            {value: 'returned', textCode: 'returned', align: 'left',},
            {value: 'overdue', textCode: 'overdue', align: 'left',},
        ],
    },
};

const getters = {
    getSdtHeader: (state) => (entity) => state.sdtHeaders[entity],
    getSdtRowsByEntity: (state) => (entity) => state.sdtRows[entity] || [],
    getSdtConfig: (state) => (entity) => state.sdtConfig[entity],
};
const actions = {
    async storeSdtRows({commit, getters, dispatch}, payload) {
        const {http} = await getApi();
        const configs = getters.getSdtConfig(payload.entity)
        let requestParams = {}
        if (['CtlgPrivilege', 'CtlgRole'].includes(payload.entity)) {
            requestParams.userId = payload.entityId;
        }
        if (payload.entity === 'Asset') {
            requestParams.where = [
                {value: 'employeeId', text: payload.entityId}
            ]
        }
        if (payload.entity === 'EmployeeDiscipline') {
            requestParams.where = [
                {value: 'employeeId', text: payload.entityId}
            ]
        }
        if (payload.entity === 'AssetHistory') {
            requestParams = {
                assetId: (getters.getRouteName === 'AssetPage') ? payload.entityId : null,
                employeeId: (getters.getRouteName === 'EmployeePage') ? payload.entityId : null,
                lang: getters.getChosenLang.toLowerCase(),
                sort: payload.pagination
            }
        }
        if (payload.entity === 'AssetMaintenance') {
            requestParams.where = [
                {value: 'assetId', text: payload.entityId}
            ]
            requestParams.lang = getters.getChosenLang.toLowerCase();
        }
        if (payload.entity === 'AssetMaintenanceHistory') {
            requestParams.where = [
                {value: 'assetId', text: payload.entityId}
            ]
            requestParams.lang = getters.getChosenLang.toLowerCase();
        }
        if (payload.entity === 'IpmProvision') {
            requestParams.where = [
                {value: 'employeeId', text: payload.entityId}
            ]
        }
        try {
            const response = await http.getData(configs.url, requestParams)
            if (response.status === 200 && response.data[configs.respObject]) {
                let result = response.data[configs.respObject]
                if (payload.entity === 'AssetHistory') {
                    result = result.map(item => {
                        item.eventName = (item.event)?item.event.name:'';
                        item.assetNumber = (item.asset) ? item.asset.identNumber : ''
                        item.assetModel = (item.asset && item.asset.model) ? item.asset.model.code : ''
                        item.employeeNumber = (item.employee && item.employee.id) ? item.employee.identNumber : ''
                        item.employeeName = (item.employee && item.employee.id) ? `${item.employee.fname} ${item.employee.lname}` : ''
                        item.issueDP = (item.issueDistPoint) ? item.issueDistPoint.name : ''
                        item.returnDP = (item.returnDistPoint) ? item.returnDistPoint.name : ''
                        return item
                    })
                }
                commit('setSdtRows', {entity: payload.entity, rows: result});
                return response.data[configs.respObject]
            } else if(response.status !== 200){
                dispatch('storeError', response, {root: true});
            }
        } catch (e) {
            dispatch('storeError', e, {root: true});
        }
    },


};
const mutations = {
    setSdtRows: (state, data) => {
        state.sdtRows = {...state.sdtRows, [data.entity]: data.rows}
    },


};

export default {
    state,
    getters,
    actions,
    mutations
}
